import React, {Component} from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import {Formik} from 'formik';
import _ from 'lodash';
import config from '../config';
import JsonEditorComponent from '../JsonEditorComponent'
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {downloadFile, readFileAsync} from "../components/ImportExport";

export default class GameServers extends Component {
    static contextType = AuthContext

    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {items:[]};
        this.init = this.init.bind(this);
        this.intervalId = null;
    }
// Вызывается один раз при монтировании компонента
    componentDidMount() {
        this.init(); // Первый вызов
        this.intervalId = setInterval(this.init, 5000); // Запуск обновления каждые 5 секунд
    }

    // Очистка при размонтировании компонента
    componentWillUnmount() {
        if (this.intervalId) {
            clearInterval(this.intervalId); // Остановка интервала
        }
    }
    async init() {

        let json1 = await fetcher(`${config.API()}../gameservers/info/get`);
        let data = await json1.json()

        this.setState({
            items: Object.values(data.info),
        })
    }

    render() {
        return (
            <div>
                <div className="card shadow w100">
                    <div className="card-header py-3">
                        <h2 className="m-0 font-weight-bold l"> Game Servers</h2>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                                <table className="dataTable table table-align-middle table-bordered table-sm" width="100%" cellSpacing="0">
                                <thead>
                                <tr className="small">
                                    {this.state.items.length > 0 &&
                                        Object.keys(this.state.items[0]).map(key =><th key={`th-${key}`}>{key}</th>)}
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.items.map((x, i) =>
                                    <tr key={`o-${i}`}>
                                        {Object.keys(x).map(key => <td key={`td-${key}`}>{x[key]}</td>)}
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

            </div>
        );
    }
}
